import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/styles';
import Auth from "../../../../utils/Auth";
import clsx from 'clsx';
import { FormControlLabel, FormLabel, RadioGroup, FormHelperText, FormControl, Radio, Button, Tooltip } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import InfoIcon from '@material-ui/icons/Info';
import Utils from "../../../../utils/Utils";
import { setRegisterModalOpened } from './../../../../users/actions/users.actions';

class AccumulatedOrderAmount extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.setState({ errors: '' });
    }

    useAmount() {
        this.props.onChangeParams('accumulatedOrderAmountUsed', 1)
    }

    removeAmount() {
        this.props.onChangeParams('accumulatedOrderAmountUsed', 0)
    }

    render() {
        // const orderTypeUsedForPaymentMethodLabel = this.props.currentOrderType == 2 ? '_delivery' : ''
        let { settings } = this.props;
        const default_currency_suffix = (settings.default_currency_suffix && settings.default_currency_suffix.value ? settings.default_currency_suffix.value : 'лв.')

        let priceToAccumulate = 0;
        if (this.props.accumulatedOrderAmountSetting) {
            priceToAccumulate = (this.props.finalPrice * this.props.accumulatedOrderAmountSetting.percent / 100).toFixed(2);
        }

        return (
            <React.Fragment>
                {this.props.accumulatedOrderAmountSetting ?
                    <React.Fragment>
                        {Auth.getDecodedUser() && this.props.accumulatedOrderAmountSetting ?
                            <div style={{ paddingTop: 5, paddingBottom: 5, textAlign: "center" }}>
                                {this.props.accumulatedOrderAmountSetting.accumulatedUserAmount > 0 ?
                                    <React.Fragment>
                                        {priceToAccumulate > 0 ?
                                            <p>{this.props.translations.accumulated_order_amount.complete_your_order_and_accumulate} {priceToAccumulate} {default_currency_suffix}

                                                {Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ?
                                                    <>
                                                        |{(Utils.showPricesInEuroCurrency(priceToAccumulate))}
                                                    </>
                                                    :
                                                    null
                                                }&nbsp;

                                                {this.props.translations.accumulated_order_amount.for_you_next_order}</p>
                                            :
                                            null}

                                        <span>{this.props.translations.accumulated_order_amount.you_have_accumulated} {this.props.accumulatedOrderAmountSetting.accumulatedUserAmount.toFixed(2)} {default_currency_suffix}

                                            {Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ?
                                                <>
                                                    |{(Utils.showPricesInEuroCurrency(this.props.accumulatedOrderAmountSetting.accumulatedUserAmount.toFixed(2)))}
                                                </>
                                                :
                                                null
                                            }&nbsp;

                                        </span>

                                        {this.props.accumulatedOrderAmountUsed ?
                                            <Button variant="outlined" onClick={() => this.removeAmount()} className="" style={{ float: 'right' }}>
                                                {this.props.translations.accumulated_order_amount && this.props.translations.accumulated_order_amount.remove ? this.props.translations.accumulated_order_amount.remove : ''}
                                            </Button>
                                            :
                                            <Button variant="outlined" onClick={() => this.useAmount()} className="" disableRipple style={{ float: 'right' }}>
                                                {this.props.translations.accumulated_order_amount && this.props.translations.accumulated_order_amount.use ? this.props.translations.accumulated_order_amount.use : ''}
                                            </Button>
                                        }


                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        {priceToAccumulate > 0 ?
                                            <p>{this.props.translations.accumulated_order_amount.complete_your_order_and_accumulate} {priceToAccumulate} {default_currency_suffix}

                                                {Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ?
                                                    <>
                                                        |{(Utils.showPricesInEuroCurrency(priceToAccumulate))}
                                                    </>
                                                    :
                                                    null
                                                }&nbsp;

                                                {this.props.translations.accumulated_order_amount.for_you_next_order}</p>
                                            :
                                            <span>{this.props.translations.accumulated_order_amount.no_accumulated_money_text}</span>

                                        }
                                    </React.Fragment>
                                }
                            </div>
                            :
                            <React.Fragment>
                                <p style={{ textAlign: 'center', paddingTop: 5 }}>
                                    <Button onClick={() => this.props.setRegisterModalOpened(true)} variant="outlined" style={{ fontSize: 12 }}>
                                        {this.props.translations.accumulated_order_amount.register_and_accumulate} {priceToAccumulate} {default_currency_suffix}

                                        {Utils.getSettingsValue(settings, 'show_prices_in_two_currency') == '1' ?
                                            <>
                                                |{(Utils.showPricesInEuroCurrency(priceToAccumulate))}
                                            </>
                                            :
                                            null
                                        }&nbsp;

                                        {this.props.translations.accumulated_order_amount.for_you_next_order}
                                    </Button>
                                </p>
                            </React.Fragment>
                        }
                    </React.Fragment>
                    :
                    null
                }

            </React.Fragment>
        )
    }

}



const mapStateToProps = (state, ownProps) => {

    return {
        translations: state.lang.translations,
        accumulatedOrderAmountSetting: state.accumulatedOrderAmountSetting.setting,
        settings: state.settings.settings || [],
    }
};

export default (connect(mapStateToProps, { setRegisterModalOpened })(AccumulatedOrderAmount));
